import axios from 'axios'

const DATALINK_APIS = {
  HISTORY: 'file_logs',
  PRE_SIGNED_URL: 's3_presign/upload',
  DELETE_HISTORY: 'file_delete',
  DETAILS: 'file_log',
  OUTPUT: 'output',
  SEND_TO_VIRTUSIZE: 'file_send'
}

const instanceForDataLink = axios.create({
  baseURL: process.env['VUE_APP_DATALINK_API'],
  headers: {}
})

const getHistory = async (storeName, pageNum, numberOfItemPerPage) => {
  const params = {
    p: pageNum,
    num: numberOfItemPerPage
  }
  try {
    let history = (await instanceForDataLink.get(
      `/${DATALINK_APIS.HISTORY}/${storeName}`, { params }
    ))
    return history.data
  } catch (e) {
    return []
  }
}
const getDetails = async (storeName, fileTimestamp) => {
  try {
    const details = await Promise.all([
      instanceForDataLink.get(`/${DATALINK_APIS.DETAILS}/${storeName}/${fileTimestamp}`),
      instanceForDataLink.get(`/${DATALINK_APIS.OUTPUT}/${storeName}/${fileTimestamp}`)
    ])
    return {
      info: details[0].data,
      data: details[1].data
    }
  } catch (e) {
    return null
  }
}
const getSignedUrl = async (storeName, payload) => {
  try {
    const params = {
      files: payload.map(file => {
        return {
          'file_name': file.name,
          'file_type': file.type
        }
      })
    }
    let urls = (await instanceForDataLink.post(`${DATALINK_APIS.PRE_SIGNED_URL}/${storeName}`, params)).data.signed_urls
    return urls
  } catch (e) {
    return []
  }
}
const deleteHistory = async (storeName, fileTimestamp) => {
  return instanceForDataLink.delete(
    `/${DATALINK_APIS.DELETE_HISTORY}/${storeName}/${fileTimestamp}`
  )
}

const sendToVirtusize = async (storeName, fileTimestamp) => {
  return instanceForDataLink.get(
    `/${DATALINK_APIS.SEND_TO_VIRTUSIZE}/${storeName}/${fileTimestamp}`
  )
}

export default {
  getHistory,
  getSignedUrl,
  deleteHistory,
  getDetails,
  sendToVirtusize
}
